import { BRAND } from '@/brand';

/** The X and Telegram marks (Simple Icons, CC0): lucide carries no brand logos. */
const ICONS = {
  x: 'M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z',
  telegram:
    'M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z',
} as const;

const NAMES: Record<keyof typeof BRAND.social, string> = { x: 'X', telegram: 'Telegram' };

/** The platform's own accounts as icon links. Brand names need no translation. */
export function SocialLinks({ className }: { className?: string }) {
  return (
    <div className={className}>
      {(Object.keys(BRAND.social) as (keyof typeof BRAND.social)[]).map((key) => {
        const url = BRAND.social[key];
        const handle = `@${url.split('/').pop()}`;
        return (
          <a
            key={key}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${NAMES[key]} ${handle}`}
            title={`${NAMES[key]} ${handle}`}
          >
            <svg viewBox="0 0 24 24" width={16} height={16} fill="currentColor" aria-hidden="true">
              <path d={ICONS[key]} />
            </svg>
          </a>
        );
      })}
    </div>
  );
}
